export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14662.d8721461.jpg";